import React, { Fragment } from "react";
import { dataFormatters } from "../../../utils/dataFormatters";
import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";
import { getArrayToDict, getDictToArray } from "./arrayToDict";
import {
  getAssetMarkerCombined,
  getAssetMilepost,
  getAssetMilepostWithPrefix,
  getStartEndMilepostWithPrefix,
  getAssetMilepostWithPrefixFromStartEnd,
} from "./getAssetMileport";
import { getFormSummary } from "./getFormSummary";
import { getIssueCodeDescription } from "./getIssueCodeDescription";
import { getIssueRemedialActionComments, getIssueRemedialActionSlashCommentsForSepta } from "./getIssueRemedialActionComments";
import { getRepairedBySummary } from "./getRepairedBySummary";
import { SignatureImage } from "./SignatureImage";
import _ from "lodash";
import { TickRenderer } from "../../../libraries/ReportGenerator/TickRenderer";
import { yardTypeATypeTracks } from "../../../AssetTypeConfig/Reports/DefectReportConfig";
import { checkInspected } from "../Timps/YardTrackInspection/YardTrackDefectReport";
import { remedialActionUtil } from "../../../config/RemedialActionConfig";

export const LampInspectionTypes = {
  weather: "weather",
  special: "special",
  required: "required",
};

export const TrackTraversedByOptions = {
  "Hi-Rail": "Hi-Rail",
  Walking: "Walking",
  train: "train",
};

const getMarkerOrMp = (milepostWithMp, marker) => {
  return marker ? marker : milepostWithMp;
};

const isAssetInspected = (unit) => {
  let inspected = false;
  if (unit.appForms && unit.appForms.length > 0) {
    for (let appForm of unit.appForms) {
      if (appForm && inspected == false) {
        if (appForm.form) {
          inspected = checkInspected(appForm);
        }
      }
    }
  }
  return inspected;
};

export const ReportGeneratorUtils = {
  getIssueAppFormSummary: (issue, formId) => {
    let summary = {};
    if (issue && Array.isArray(issue.appForms)) {
      let appForm = issue.appForms.filter((form) => form).find((form) => form.id === formId);
      if (appForm) {
        summary = getFormSummary(appForm);
      }
    }

    return summary;
  },

  getTraverseBy: (inspec) => {
    let traverseBy = null;
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      traverseBy = task.traverseBy;
    }
    return traverseBy;
  },

  getInspectionAppForms: (inspec, formIds = []) => {
    let forms = [];
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.appForms && Array.isArray(task.appForms)) {
        forms = task.appForms.filter((form) => form && formIds.includes(form.id)).map((form) => getFormSummary(form));
      }
    }
    return forms;
  },

  getInspectionAssetAppForms: (inspec, formIds = [], assetId, includeTestCode) => {
    let forms = [];
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.units && Array.isArray(task.units)) {
        task.units.forEach((unit) => {
          if (unit.id === assetId) {
            if (unit.appForms && Array.isArray(unit.appForms)) {
              forms = unit.appForms
                .filter((form) => form && formIds.includes(form.id))
                .map((form) => {
                  let result = getFormSummary(form);
                  return { ...(includeTestCode && { testCode: form.id }), ...result };
                });
            }
          }
        });
      }
    }
    return forms;
  },

  getInspectionTableAppForms: (inspec, formIds = []) => {
    let forms = [];
    let tableForms = [];
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.appForms && Array.isArray(task.appForms)) {
        forms = task.appForms.filter((form) => form && formIds.includes(form.id)).map((form) => getFormSummary(form));
      }
      if (Array.isArray(forms)) {
        forms.length > 0 && forms.map((form) => (Array.isArray(form.tblBatt) ? tableForms.push(...form.tblBatt) : tableForms.push(form)));
      }
    }
    return tableForms;
  },
  // getMaintenanceAppForms: (inspec, formIds = []) => {
  //   let forms = [];
  //   if (inspec && inspec.tasks && inspec.tasks.length > 0) {
  //     let task = inspec.tasks[0];
  //     if (task.maintenance && Array.isArray(task.maintenance)) {
  //       task.maintenance.forEach((m) => {
  //         if (m.appForms && Array.isArray(m.appForms)) {
  //           forms = [...forms, ...m.appForms.filter((form) => form && formIds.includes(form.id)).map((form) => getFormSummary(form))];
  //         }
  //       });
  //     }
  //   }
  //   return forms;
  // },

  getMaintenanceAppForms: (inspec, formIds = [], includeTestCode) => {
    let forms = [];
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.maintenance && Array.isArray(task.maintenance)) {
        task.maintenance.forEach((m) => {
          if (m.appForms && Array.isArray(m.appForms)) {
            forms = [
              ...forms,
              ...m.appForms
                .filter((form) => form && formIds.includes(form.id))
                .map((form) => {
                  let result = getFormSummary(form);
                  console.log(form);
                  return form && form.formId
                    ? {
                        formId: form.formId,
                        ...(includeTestCode && { testCode: form.id }),
                        ...result,
                      }
                    : { ...(includeTestCode && { testCode: form.id }), ...result };
                }),
            ];
          }
        });
      }
    }
    return forms;
  },

  checkIfMaintenance: (inspec) => inspec && (inspec.planType === "Maintenance" || inspec.planType === "New Work Order"),
  getInspectionAssetsWithForm: (
    inspec,
    assetFilterFunction = (assetType) => false,
    formId, // can be a string if its a single formId otherwise can be an array if more than one form data needs be extracted.
    allowMissedForms,
    includeIssues,
    usersSignatures,
    inspectedOnly = false,
    includeMajorDefect = true,
    filterDefeciencyWithFraCheck = false,
    sortBy = [],
    sortOrder = [],
  ) => {
    let assets = [];
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.units && task.units.length > 0) {
        assets = task.units
          .filter((asset) => assetFilterFunction(asset.assetType))
          .map((asset) => {
            let assetSummary = {
              switchName: asset.unitId,
              assetName: asset.unitId,
              attributes: asset.attributes,
              assetId: asset.id,
              startMp: parseFloat(asset.start),
              milepost: getAssetMilepost(asset),
              milepostWithMp: getAssetMilepostWithPrefix(asset, inspec.lineId),
              marker: getAssetMarkerCombined(asset),
              summary: null,
              mpPrefix: LocPrefixService.getPrefixMp(asset.start, inspec.lineId),
              issues: [],
            };
            assetSummary.markerOrMp = getMarkerOrMp(assetSummary.milepostWithMp, assetSummary.marker);

            if (inspectedOnly) {
              // no need for summary
              // allow only if this asset is inspected
              if (isAssetInspected(asset)) {
                assetSummary.summary = { inspected: true };
              }
            } else {
              // all if a particuar form has been filled
              if (asset.appForms && asset.appForms.length > 0) {
                let appForm = asset.appForms.filter((form) => form).find((form) => form.id === formId);
                if (appForm) {
                  assetSummary.summary = getFormSummary(appForm);
                }
              }
            }

            return assetSummary;
          });

        if (includeIssues) {
          let tempAssetsKeyVal = getArrayToDict(assets, "assetId");
          task.issues &&
            task.issues
              .filter((issue) => {
                if (issue.issueType === "Deficiency" && filterDefeciencyWithFraCheck) {
                  return issue.serverObject && issue.serverObject.includeFRAReport === true;
                } else return true;
              })
              .forEach((issue) => {
                if (tempAssetsKeyVal[issue.unit.id]) {
                  let codeDescription = getIssueCodeDescription(issue, includeMajorDefect);
                  let issueSummary = {
                    startMp: parseFloat(issue.startMp),
                    milepostWithMp: getAssetMilepostWithPrefixFromStartEnd(inspec.lineId, issue.startMp, issue.endMp),
                    marker: getAssetMarkerCombined(issue),
                    detectCodes: codeDescription.majorDefectCode + codeDescription.minorDefectCode,
                    detectDescription: codeDescription.minorDescription,
                    userComments: getIssueRemedialActionComments(issue),
                    remedialAction_slash_Comments_forSepta: getIssueRemedialActionSlashCommentsForSepta(issue),
                    defectRepaired: getRepairedBySummary(issue, usersSignatures),
                    selfRepair: remedialActionUtil(issue.remedialAction, "repaired"),
                    description: issue.description,
                    remedialAction: issue.remedialAction,
                    issueType: issue.issueType,
                    deficiencyTick: TickRenderer(issue.issueType, "Deficiency"),
                    defectTick: TickRenderer(issue.issueType, "Defect"),
                    rule213B: TickRenderer(issue.ruleApplied, true),
                    septaIssueDetailForm: ReportGeneratorUtils.getIssueAppFormSummary(issue, "septaIssueDetailForm"),
                  };
                  issueSummary.markerOrMp = getMarkerOrMp(issueSummary.milepostWithMp, issueSummary.marker);
                  issueSummary.remedialAction_slash_Comments = [issueSummary.remedialAction, issueSummary.userComments]
                    .map((v) => v)
                    .map((val) => val.trim())
                    .filter((v) => v !== "")
                    .join(" / ");

                  issueSummary.defects_comments = `${issueSummary.detectCodes} ${
                    issueSummary.detectDescription ? "-" + issueSummary.detectDescription : ""
                  }  ${issueSummary.userComments ? "/ " + issueSummary.userComments : ""}`;
                  tempAssetsKeyVal[issue.unit.id].issues.push(issueSummary);
                  issueSummary.repairedByAndDate = (
                    <Fragment>
                      {issueSummary.selfRepair ? (
                        <div>{inspec.user.name} </div>
                      ) : issueSummary.defectRepaired.name ? (
                        <div> {issueSummary.defectRepaired.name}</div>
                      ) : null}
                      {issueSummary.selfRepair ? (
                        <div>{dataFormatters.dateFormatter(inspec.date)}</div>
                      ) : issueSummary.defectRepaired.date ? (
                        <div> {issueSummary.defectRepaired.date} </div>
                      ) : null}
                    </Fragment>
                  );
                  issueSummary.dateRepaired = (
                    <Fragment>
                      {issueSummary.defectRepaired.date ? (
                        <div> {issueSummary.defectRepaired.date} </div>
                      ) : issueSummary.selfRepair ? (
                        <div>{dataFormatters.dateFormatter(inspec.date)}</div>
                      ) : null}
                    </Fragment>
                  );

                  issueSummary.repairedBySignature = (
                    <Fragment>
                      <SignatureImage
                        placement={"tableCell"}
                        signatureImage={
                          issueSummary.selfRepair
                            ? inspec.user && inspec.user.signature && inspec.user.signature
                            : issueSummary.defectRepaired.signature
                        }
                      />
                    </Fragment>
                  );
                }
              });
          assets = getDictToArray(tempAssetsKeyVal);
        }
        // keep switches/assets where the form is not filled
        !allowMissedForms && (assets = assets.filter((asset) => asset.summary || (asset.issues && asset.issues.length > 0)));

        // sort intervals if required
        if (Array.isArray(sortBy) && sortBy.length > 0) {
          assets = _.orderBy(assets, sortBy, sortOrder);
        }
      }
    }
    assets = assets.map((asset) => {
      if (asset.issues.length === 0) {
        asset.issues.push({
          startMp: asset.startMp,
          milepostWithMp: asset.milepostWithMp,
          marker: asset.marker,
          markerOrMp: getMarkerOrMp(asset.milepostWithMp, asset.marker),
          remedialAction_slash_Comments: "No Exception Found",
          remedialAction_slash_Comments_forSepta: "No Exception Found",
        }); // add no exception found message for if there are no issues.
      }
      return asset;
    });
    return assets;
  },
  getUserSignature: (user, usersSignatures) => {
    let foundUser = usersSignatures.find((sig) => sig.email === user.email);
    let imgName = foundUser && foundUser.signature ? foundUser.signature.imgName : undefined;
    return imgName;
  },
  getJobBriefingTitle: (inspec) => {
    // return inspec && inspec.planType === "Job Briefing" ? inspec.title : null;
    return inspec.title;
  },

  getInspectionJobBriefings: (inspec) => {
    let toRet = {};
    let workers = [];
    let reviewComments = [];
    let signatures = [];

    if (inspec && inspec.jobBriefings) {
      inspec.jobBriefings = inspec.jobBriefings
        .filter((briefing) => briefing)
        .map((briefing) => {
          let formId = null;
          if (briefing.reviewComments) reviewComments.push(briefing.reviewComments);
          if (briefing.signature) signatures.push(briefing.signature);
          briefing &&
            briefing.jobBriefingForms &&
            Array.isArray(briefing.jobBriefingForms) &&
            (briefing.jobBriefingForms = briefing.jobBriefingForms
              .filter((form) => form && form.id)
              .map((form) => {
                // take the id of first form and search for all forms with same types
                if (formId === null) {
                  formId = form.id;
                }
                return form.id === form.id ? form : null;
              })
              .filter((form) => form && form.id));
          briefing.formId = formId;
          briefing.workers && briefing.workers.length > 0 && (workers = [...workers, ...briefing.workers]);
          return briefing;
        })
        .filter((briefing) => briefing.formId);
      toRet.briefings = inspec.jobBriefings ? inspec.jobBriefings : null;
      toRet.workers = workers;
      toRet.reviewComments = reviewComments.length > 0 ? reviewComments : null;
      toRet.signatures = signatures.length > 0 ? signatures : null;
    }

    return toRet;
  },

  getInspectionLocation: (inspec) => {
    let location = "";
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.units && task.units.length > 0) {
        location = task.units[0].unitId;
      }
    }
    return location;
  },
  getMaintenanceLocation: (inspec) => {
    let location = "";
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.orgMaintenances && task.orgMaintenances.length > 0 && task.orgMaintenances[0].parentAsset)
        return task.orgMaintenances[0].parentAsset.unitId;
      else if (inspec && inspec.lineName) return inspec.lineName;
    }
    return location;
  },
  getMaintenanceSubdivision: (inspec) => {
    let subdivision = "";
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.orgMaintenances && task.orgMaintenances.length > 0) {
        const parentAsset = task.orgMaintenances[0].parentAsset;
        if (parentAsset && parentAsset.parentAsset) {
          subdivision = parentAsset.parentAsset.unitId;
        }
      }
    }
    return subdivision;
  },

  getMaintenanceAfeNumber: (inspec) => {
    let AfeNumber = "";
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.orgMaintenances && task.orgMaintenances.length > 0) {
        AfeNumber = task.orgMaintenances[0].afeNumber;
      }
    }
    return AfeNumber;
  },

  getMaintenanceChargeCode: (inspec) => {
    let chargeCode = "";
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.orgMaintenances && task.orgMaintenances.length > 0) {
        chargeCode = task.orgMaintenances[0].chargeCode;
      }
    }
    return chargeCode;
  },
  getInspectionSubdivision: (inspec) => {
    let subdivision = "";
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.units && task.units.length > 0) {
        const { parentAsset } = task.units[0];
        parentAsset && parentAsset.unitId && (subdivision = parentAsset.unitId);
      }
    }
    return subdivision;
  },
  getInspection1stTaskAssetId: (inspec) => {
    let assetId = null;
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.units && task.units.length > 0) {
        assetId = task.units[0].id;
      }
    }
    return assetId;
  },
  getInspectionDate: (inspec) => {
    return inspec && inspec.date;
  },
  getInspectionUser: (inspec) => {
    return inspec && inspec.user;
  },
  getInspectionLineName: (inspec) => {
    return inspec && inspec.lineName;
  },
  getInspectionWeather: (inspec) => {
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      let tempUnit = task.tempUnit ? task.tempUnit : "";
      let temp = task.temperature || task.temperature == 0 ? task.temperature + " " + tempUnit : "";
      let weatherVal = task.weatherConditions ? task.weatherConditions : "";
      return temp ? temp + (weatherVal ? ", " + weatherVal : "") : weatherVal ? weatherVal : "";
    }
    return null;
  },
  getInspectionType: (inspec) => {
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      return task.inspectionTypeTag;
    }
    return null;
  },
  getInspectionTypeDescription: (inspec) => {
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      return task.inspectionTypeDescription;
    }
    return null;
  },
  getInspectionIntervals: (inspec, sortBy = [], sortOrder = []) => {
    let returnIntervals = [];
    if (inspec && inspec.tasks && inspec.intervals && inspec.tasks.length > 0) {
      const { intervals } = inspec;
      let task = inspec.tasks[0];
      const { traverseBy } = task;
      if (Array.isArray(intervals)) {
        intervals.forEach((interval) => {
          let { observed, traversed } = interval;
          observed === "" && (observed = null);
          traversed === "" && (traversed = null);
          const intervalFields = {
            start: parseFloat(interval.start),
            end: parseFloat(interval.end),
          };
          if (observed) {
            returnIntervals.push({
              assetId: observed,
              observed: true,
              ...intervalFields,
            });
          }
          if (traversed) {
            returnIntervals.push({
              assetId: traversed,
              traversed: true,
              traverseBy: traverseBy,
              ...intervalFields,
            });
          }
        });
      }

      if (Array.isArray(task.units) && task.units.length > 0) {
        returnIntervals = returnIntervals.map((interval) => {
          let unit = task.units.find((unit) => unit.id === interval.assetId);
          if (unit) {
            // unit (asset) found in the list
            interval.unitId = unit.unitId;
            interval.primaryTrack = unit.attributes && unit.attributes.primaryTrack;
            // readjust milepost values lying outside
            interval.start = Math.max(unit.start, interval.start);
            interval.end = Math.min(unit.end, interval.end);
          }
          return interval;
        });

        // asset type yard handling
        returnIntervals.push(
          ...task.units
            .filter((unit) => yardTypeATypeTracks.includes(unit.assetType))
            .filter((unit) => isAssetInspected(unit))
            .map((unit) => {
              return {
                assetId: unit.id,
                traversed: true,
                traverseBy: traverseBy,
                unitId: unit.unitId,
                startMarker: unit.startMarker !== "" ? unit.startMarker : null,
                endMarker: unit.endMarker !== "" ? unit.endMarker : null,
                start: parseFloat(unit.start),
                end: parseFloat(unit.end),
              };
            }),
        );
      }
    }

    // compute milepost with prefix
    returnIntervals = returnIntervals.map((interval) => {
      const { startMarker, endMarker } = interval;
      if (startMarker || endMarker) {
        interval.startWithMp = startMarker;
        interval.endWithMp = endMarker;
      } else {
        const startEndMpWithPrefix = getStartEndMilepostWithPrefix(inspec.lineId, interval.start, interval.end);
        interval.startWithMp = startEndMpWithPrefix.start;
        interval.endWithMp = startEndMpWithPrefix.end;
      }
      return interval;
    });

    // sort intervals if required
    if (Array.isArray(sortBy) && sortBy.length > 0) {
      returnIntervals = _.orderBy(returnIntervals, sortBy, sortOrder);
    }

    return returnIntervals;
  },
  getAdditionalComments: (inspec) => {
    return inspec && Array.isArray(inspec.intervals)
      ? inspec.intervals
          .filter((interval) => typeof interval.additionalInfo === "string") // check if type is valid
          .map((interval) => interval.additionalInfo.trim()) // extract comments
          .filter((interval) => interval.length > 0) // filter empty strings
      : [];
  },

  getInspectionAppFormReportVersion: (inspec, formId) => {
    let version = null;
    if (inspec && inspec.tasks && inspec.tasks.length > 0) {
      let task = inspec.tasks[0];
      if (task.units && task.units.length > 0) {
        task.units.forEach((unit) => {
          if (unit.appForms && Array.isArray(unit.appForms)) {
            unit.appForms.forEach((form) => {
              if (form.id === formId) {
                if (form.ver) version = form.ver;
              }
            });
          }
        });
      }
    }
    return version;
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/reportGeneratorUtils.js